import { render } from "./WorksMarkForm.vue?vue&type=template&id=4fb57ece&lang=pug"
import script from "./WorksMarkForm.vue?vue&type=script&lang=js"
export * from "./WorksMarkForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__